import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineLinkIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m10 17.55-1.77 1.72a2.475 2.475 0 0 1-4.225-1.75c0-.6564.2608-1.2859.725-1.75l4.54-4.55a2.4601 2.4601 0 0 1 3.39-.09l.12.1a1.0008 1.0008 0 0 0 1.415-.015A1.0007 1.0007 0 0 0 14.18 9.8a2.7807 2.7807 0 0 0-.18-.21 4.4602 4.4602 0 0 0-6.09.22l-4.6 4.55a4.48 4.48 0 0 0 6.33 6.33L11.37 19a1.0003 1.0003 0 0 0-.0103-1.3625A1.0002 1.0002 0 0 0 10 17.55ZM20.69 3.31a4.4903 4.4903 0 0 0-6.33 0L12.63 5a.9997.9997 0 0 0 .6729 1.6737A1.0001 1.0001 0 0 0 14 6.45l1.73-1.72a2.4748 2.4748 0 1 1 3.5 3.5l-4.54 4.55a2.4601 2.4601 0 0 1-3.39.09l-.12-.1a1.0007 1.0007 0 1 0-1.4 1.43 2.738 2.738 0 0 0 .23.21 4.4701 4.4701 0 0 0 6.09-.22l4.55-4.55a4.4901 4.4901 0 0 0 .04-6.33Z"/>
  </SvgIcon>
}

export default LineLinkIcon
